// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2eHrp","noInteraction":"EventWrapper_noInteraction__21h9s"};